/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

export interface MarketplaceProductOptions {
  optionalTargetingTypes: string[];
  layoutCategories: string[];
  labels: string[];
  adSizes: string[];
}

@Injectable({providedIn: 'root'})
export class MarketplaceProductOptionsApiService {
  private readonly uri = this.apiConfig.getVersionedUri('axproduct/options');

  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(): Observable<MarketplaceProductOptions> {
    return this.client.request<MarketplaceProductOptions>({
      method: 'GET',
      url: this.uri
    });
  }
}
